import {
  RETRIEVE_BUS_LIST,
  CREATE_BUS,
  GET_BUS_INFO,
  EDIT_BUS,
  DELETE_BUS,
  GET_BUS_LAYOUT,
  GET_STUDENT_LIST_FOR_BUS,
  UPDATE_BUS_SEAT_MAP,
  GET_AVAILABLE_PLATE_LIST,
  RETRIEVE_BUS_HISTORY_STUDENT_LIST,
  BUS_HISTORY_STUDENT_CANCEL,
  BUS_HISTORY_STUDENT_NOTE,
  BUS_HISTORY_STUDENT_BOOK,
  BUS_HISTORY_ADD_STUDENT,
  EXPORT_BUS_SEAT_MAP
} from '@/api'

export default {
  retrieveBusList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      // console.log(response);
      if (response.data.data.bus_list.length) {
        commit('retrieveBusList', {busList: response.data.data.bus_list})
      }

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }

    RETRIEVE_BUS_LIST({}, successCallback, errorCallback)
  },

  createBus({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.bus_info) {
        commit('retrieveBusList', {busList: response.data.data.bus_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    CREATE_BUS({data: payload.data}, successCallback, errorCallback)
  },

  editBus({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.bus_info) {
        // commit('retrieveBusList', {busList: response.data.data.bus_info})
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
      }
    };

    EDIT_BUS({data: payload}, successCallback, errorCallback)
  },

  getBusInfo(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_BUS_INFO({payload}, successCallback, errorCallback)
  },

  deleteBus({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      commit('deleteBus', {busInfo: payload})

      if (typeof payload.successCallback === 'function') {
        payload.successCallback()
      }
    }
    DELETE_BUS({payload}, successCallback, errorCallback)
  },

  getBusLayoutList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.layout_list) {
        commit('getBusLayoutList', {busLayoutList: response.data.data.layout_list})
      }
    }
    GET_BUS_LAYOUT({payload}, successCallback, errorCallback)
  },

  getStudentListForBus({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }
    GET_STUDENT_LIST_FOR_BUS({payload}, successCallback, errorCallback)
  },

  getAvailablePlateList({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
      if (response.data.data.plate_list) {
        commit('getPlateList', {plateList: response.data.data.plate_list})
      }

    }
    GET_AVAILABLE_PLATE_LIST({payload}, successCallback, errorCallback)
  },

  updateBusSeatMap({commit}, payload) {
    // let errorCallback = payload.errorCallback || null
    let errorCallback = null
    let successCallback = (response) => {
        if (typeof payload.successCallback === 'function') {
          payload.successCallback()
        }
    };

    UPDATE_BUS_SEAT_MAP(payload, successCallback, errorCallback)
  },

  exportBusSeatMap(state, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    };

    EXPORT_BUS_SEAT_MAP(payload, successCallback, errorCallback)
  },

  retrieveBusHistoryStudentList({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    RETRIEVE_BUS_HISTORY_STUDENT_LIST(payload, successCallback, errorCallback)
  },

  busHistoryStudentCancel({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    BUS_HISTORY_STUDENT_CANCEL(payload, successCallback, errorCallback)
  },

  busHistoryStudentBook({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    BUS_HISTORY_STUDENT_BOOK(payload, successCallback, errorCallback)
  },

  busHistoryStudentNote({commit}, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    BUS_HISTORY_STUDENT_NOTE(payload, successCallback, errorCallback)
  },

  busHistoryAddStudent({ commit }, payload) {
    let errorCallback = payload.errorCallback || null
    let successCallback = (response) => {
      if (typeof payload.successCallback === 'function') {
        payload.successCallback(response)
      }
    }

    BUS_HISTORY_ADD_STUDENT(payload, successCallback, errorCallback)
  }
};
